




import { Vue, Prop, Component } from 'vue-property-decorator'
@Component({
  name: 'MainTitle'
})
export default class extends Vue {
  @Prop({ default: '' }) private tag!: string
}
